var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    d: "M15.7 2.3c-.4-.4-1-.4-1.4 0l-8.4 8.3-4.2-4.1c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l4.9 4.9c.4.4 1 .4 1.4 0l9.1-9c.4-.5.4-1.1 0-1.5"
  })));
};
export default SvgTick;